import React from 'react';
import { HomePageRouter } from './HomePageRouter';

export const HomePage = () => <HomePageRouter />;
